// extracted by mini-css-extract-plugin
export default {"container":"kN-z","topReviewHeading":"lN-z","criticalReview":"mN-z","favorableReview":"nN-z","vsSeparator":"oN-z"};